export const baseURL = "https://ferrywheel.arinzolive.com/";
export const adminBaseURL = "https://admin.arinzolive.com/";
export const key = "p2j3uvj8sk!7jf-z!-^wn3sd)%!zzelm52(m!d98p01t$fy)r";